/**
 * Styled Components - Created by david on 08/06/18.
 */
import styled from 'styled-components'
import AntdButton from 'antd/lib/button'
import {
  GRAY_LIGHTEST,
  WHITE,
  GRAY,
  TRANSPARENT,
  GRAY_DARK
} from '../../../theme/colors'

export const Container = styled.div`
  height: 100%;
  max-height: 260px;
  overflow: auto;
  border: 1px solid #767676;
  margin: 18px 18px 12px 18px;
  border-radius: 2px;
  scroll-behavior: smooth;
  @media only screen and (min-device-width: 1366px) and (max-device-width: 1366px) and (orientation: landscape) {
    height: 450px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    height: 350px;
    padding: 5px 5px 0px;
  }
`
type RowProps = {
  selected: boolean
}

export const Row = styled.div`
  border: 1px solid
    ${({ selected }: RowProps) => (selected ? GRAY : TRANSPARENT)};
  display: flex;
  flex: 1;
  padding: 6px 14px 8px 12px;
  background: #fbfbfb;
  position: relative;
  border: 1px solid lightgray;
`

export const Col = styled.li`
  display: inline-block;
  height: 88px;
  list-style: none;
  margin-bottom: 6px;
  text-align: center;
  width: calc(100% / 3);
`

export const Image = styled.img`
  background-color: ${GRAY_LIGHTEST};
  cursor: pointer;
  height: 88px;
  object-fit: contain;
  width: 88px;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 16px;
  padding-block: 6px;
  width: 100%;
`

export const Name = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.11px;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Size = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 10px;
  padding-top: 4px;
`

export const SizeRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const Delete = styled(AntdButton)`
  border: 1px solid #302628;
  border-radius: 225px;
  width: 72px;
  height: 28px;
  font-weight: 500;
  background: white;
  &:hover {
    background: #302628;
    color: white;
    border-color: #302628;
  }
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Buttons = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;

  @media (min-width: 768px) and (max-width: 1024px) {
    margin-top: 5px;
  }
`

export const Apply = styled(AntdButton)`
  border: 1px solid #302628;
  border-radius: 225px;
  width: 72px;
  height: 28px;
  font-weight: 500;
  background: #302628;
  margin-left: 8px;
  &:hover {
    color: #302628;
    background: white;
    border-color: #302628;
  }
`

export const LowQualityIcon = styled.img`
  position: absolute;
  width: 36px;
  left: 64px;
  top: 6px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/ImageList/styledComponents.tsx